import { render } from "./CadastrarUsusario.vue?vue&type=template&id=1359d348&scoped=true"
import script from "./CadastrarUsusario.vue?vue&type=script&lang=js"
export * from "./CadastrarUsusario.vue?vue&type=script&lang=js"

import "./CadastrarUsusario.vue?vue&type=style&index=0&id=1359d348&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1359d348"]])

export default __exports__